import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { SharedModule } from "src/app/shared/shared.module";
import { SolicitacaoArquivosRoutingModule } from "./solicitacao-arquivos-routing.module";
import { SolicitacaoArquivosPesquisaComponent } from "./pesquisa/solicitacao-arquivos.pesquisa.component";
import { SolicitacaoArquivosListagemComponent } from "./listagem/solicitacao-arquivos.listagem.component";


@NgModule({
  imports:[
      SharedModule,
      BrowserModule,
      CommonModule,
      SolicitacaoArquivosRoutingModule
  ],
  declarations:[
      SolicitacaoArquivosPesquisaComponent,
      SolicitacaoArquivosListagemComponent
  ],
  providers:[

  ]
})
export class SolicitacaoArquivosModule {}
